module.exports = __webpack_public_path__ + "i18n/fr.e27eb4acab5fb1d02eca520cd11fa7ed.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/fr.json
// module id = 1308
// module chunks = 59